/* eslint-disable no-unused-vars */
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Each } from 'components';
import { PictureIcon } from 'assets/icons';
import { useSignal, useComputed } from '@preact/signals-react';
import { ImageWithFallback, ParagraphWithTooltip } from 'components';
import { format } from 'date-fns';
import { BannerItem } from './BannerItem';

export const BannersList = ({ previewSectionImage$, currentSelectedSize$, isDisabled }) => {
  const banners = useSelector((state) => state?.creatives?.selectedCreative?.banners);

  return (
    <div>
      {
        <ItemsContainer isDisabled={isDisabled}>
          <Each
            fieldOfIndex='media_id'
            of={banners}
            render={(item, index) => {
              return (
                <BannerItem
                  previewSectionImage$={previewSectionImage$}
                  currentSelectedSize$={currentSelectedSize$}
                  item={item}
                  isDisabled={isDisabled}
                />
              );
            }}
          />
        </ItemsContainer>
      }
    </div>
  );
};

const ItemsContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  height: auto;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: ${Palette.PrimaryGray._000};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;
